import { render, staticRenderFns } from "./Otp.vue?vue&type=template&id=6a199244"
import script from "./Otp.vue?vue&type=script&lang=ts"
export * from "./Otp.vue?vue&type=script&lang=ts"
import style0 from "./Otp.vue?vue&type=style&index=0&id=6a199244&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports